import {useMemo} from 'react';
import useExperiment from '../../../../hooks/useExperiment';
import useVenmoCashFundFlag from '../../../../hooks/useVenmoCashFundFlag';
import getOverrideParams from '../../../../utils/parseUrlParams';
import {
  EXPERIMENT_CONFIGS,
  EXPERIMENT_VENMO_INTEGRATION,
} from '../../../../constants/experiments';

const useVenmoIntegrationExperiment = () => {
  const experimentName = EXPERIMENT_VENMO_INTEGRATION;

  const config = EXPERIMENT_CONFIGS[experimentName]?.[process.env.ENV];
  const {experimentId, variants} = config ?? {};

  const controlVariantId = variants?.control?.id;

  const isFeatureFlagEnabled = useVenmoCashFundFlag();

  const override = getOverrideParams(experimentId);
  const hasOverride = typeof override === 'string';

  const {
    isLoading,
    isActive,
    variant: hookVariant,
    isInControl: hookIsInControl,
  } = useExperiment({
    name: experimentName,
    isEnabled: !hasOverride && isFeatureFlagEnabled,
  });

  const resolvedVariant = hasOverride ? override : hookVariant;

  const isExperimentLoading = useMemo(() => {
    if (hasOverride) return false;

    return isLoading;
  }, [hasOverride, isLoading]);

  const isInControl = useMemo(() => {
    if (!controlVariantId) return false;
    if (!isActive) return true;

    if (hasOverride) {
      return (
        override?.toString().trim() === controlVariantId?.toString().trim()
      );
    }

    return !!hookIsInControl;
  }, [isActive, hasOverride, override, hookIsInControl, controlVariantId]);

  return useMemo(() => {
    return {
      experimentId,
      variant: resolvedVariant,
      isExperimentLoading,
      isInControl,
    };
  }, [resolvedVariant, isExperimentLoading, isInControl, experimentId]);
};

export default useVenmoIntegrationExperiment;
